import Vue from 'vue';

const formatPrice = value => {
    return value ? `₪${(value / 100).toFixed(2)}` : 0;
};

Vue.filter('formatPrice', formatPrice);
